import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

interface AnalyticsToggleProps {
  showAnalytics: boolean;
  setShowAnalytics: (value: boolean) => void;
}

const AnalyticsToggle: React.FC<AnalyticsToggleProps> = ({
  showAnalytics,
  setShowAnalytics,
}) => {
  return (
    <div className="flex justify-between items-center mb-2">
      <button
        onClick={() => setShowAnalytics(!showAnalytics)}
        className="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors"
      >
        {showAnalytics ? (
          <>
            <ChevronUp className="h-4 w-4 mr-1" />
            Hide Analytics
          </>
        ) : (
          <>
            <ChevronDown className="h-4 w-4 mr-1" />
            Show Analytics
          </>
        )}
      </button>
    </div>
  );
};

export default AnalyticsToggle;
